/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReferralUser } from './ReferralUser';
import {
    ReferralUserFromJSON,
    ReferralUserFromJSONTyped,
    ReferralUserToJSON,
} from './ReferralUser';

/**
 * 
 * @export
 * @interface ReferralReceiver
 */
export interface ReferralReceiver {
    /**
     * 
     * @type {string}
     * @memberof ReferralReceiver
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralReceiver
     */
    readonly full_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralReceiver
     */
    readonly is_pro: boolean;
}

/**
 * Check if a given object implements the ReferralReceiver interface.
 */
export function instanceOfReferralReceiver(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "full_name" in value;
    isInstance = isInstance && "is_pro" in value;

    return isInstance;
}

export function ReferralReceiverFromJSON(json: any): ReferralReceiver {
    return ReferralReceiverFromJSONTyped(json, false);
}

export function ReferralReceiverFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralReceiver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'full_name': json['full_name'],
        'is_pro': json['is_pro'],
    };
}

export function ReferralReceiverToJSON(value?: ReferralReceiver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

